import 'magnific-popup';
import $ from 'jquery';

// get variables for the function when clicking on homepage card hearts
const hearts = document.querySelectorAll('.card-house__heart.favorite');
if(hearts){
    hearts.forEach((heartIcon) => {
        heartIcon.addEventListener('click', (event)=> {
            event.preventDefault();

            let project_id = heartIcon.dataset.project;
            let model = 'project';

            addToFavorites(project_id, model, project_id, heartIcon);
        });
    });
}

// get variables for function when clicking on project_detail heart or media-gallery heart
const heartIcons = document.querySelectorAll('.favorite-btn');
if(heartIcons){
    heartIcons.forEach((heartIcon) => {
        heartIcon.addEventListener('click', (event)=> {
            event.preventDefault();

            let project_id = heartIcon.dataset.project;
            let model = 'project';

            addToFavorites(project_id, model, project_id, heartIcon);
        });
    });
}

// get variables for function when clicking on project_lot_detail heart or media-gallery heart
const heartButtons = document.querySelectorAll('.favorite-btn-lot');
if(heartButtons){
    heartButtons.forEach((heartIcon) => {
        heartIcon.addEventListener('click', (event)=> {
            event.preventDefault();

            let project_id = heartIcon.dataset.project;
            let model = 'project';

            addToFavorites(project_id, model, project_id, heartIcon);
        });
    });
}

const heartLinks = document.querySelectorAll('.card-house__heart.favorite-lot');
if(heartLinks){
    heartLinks.forEach((heartIcon) => {
        heartIcon.addEventListener('click', (event)=> {
            event.preventDefault();

            let project_id = heartIcon.dataset.project;
            let model = 'project';

            addToFavorites(project_id, model, project_id, heartIcon);
        });
    });
}

// pass project_id, model, record_id to favorite, and heartIcon to toggle style
function addToFavorites(project_id, model, record_id, heartIcon){
    console.log(project_id, model, record_id, heartIcon);
    const url = '/api/default/favorite-projects';
    const data = {
        project_id: project_id,
        model: model,
        record_id: record_id,
    }
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        dataType: 'json',
        success: function(response) {
            if(response.status === "error" && response.message === 'open-account-popup'){
                openAccountPopup();
            } else if(response.status === "success") {
                if (response.action === "deleted") {
                    toggleHeart(heartIcon);
                    handleMessage(response);
                    location.reload();
                }
                toggleHeart(heartIcon);
                handleMessage(response);
            }
        },
        error: function(error) {
            // Handle the error, if needed
            // handleMessage(error);
        }
    });
}

function openAccountPopup() {
    const accountLink = document.querySelector('#account-popup-link');

    accountLink.click();
}

function handleMessage(message){
    const messageLink = document.querySelector('#message-popup-link');
    const messagePopup = document.querySelector('#message-popup');
    messagePopup.children[0].innerHTML = message.title;
    messagePopup.children[1].innerHTML = message.message;

    messageLink.click();
}

function toggleHeart(heart) {
    toggleHeartState(heart);

    const target = heart.dataset.target; // Get the target specified in data-target attribute
    const correspondingHeart = document.getElementById(target);
    if(correspondingHeart){ // Toggle the state of the corresponding heart based on the target
        toggleHeartState(correspondingHeart);
    }
}

function toggleHeartState(heart) {
    const icon = heart.children[0];
    if (icon.classList.contains('icon-heart-alt')) {
        icon.classList.remove('icon-heart-alt');
        icon.classList.add('icon-heart');
    } else {
        icon.classList.remove('icon-heart');
        icon.classList.add('icon-heart-alt');
    }
}

export default (element) => {}